import {action, computed, observable} from "mobx";
import api from '../utils/api';
import ProductStore from './ProductStore';

//const API_URI = "http://localhost:3000";

class User {

    @observable id;
    @observable name;
    @observable password;
    @observable email;
    @observable phone;
    @observable profile;
    @observable slug;
    @observable auth_key;
    @observable avatarUri;

    constructor(user) {
        this.id = user.id;
        this.auth_key = user.auth_key;
        this.email = user.email;
        this.name = user.name;
        this.phone = user.phone;
        this.profile = user.profile;
        this.slug = user.slug;
        this.avatarUri = user.avatarUri;
        this.password = user.password_hash === undefined || !user.password_hash ? '' : user.password_hash;
    }
}

/**
 * Gerencia autenticação do usuário
 */
class AuthStore {

    @observable user;
    @observable isLogged;
    @observable isLoading = false;
    @observable units = []; // Units that the user has access to

   constructor() {
    const userJson = localStorage.getItem('user-wup-teachers-desk');
    const unitsJson = localStorage.getItem('units-wup-teachers-desk');
    const isLogged = localStorage.getItem('isLogged-wup-teachers-desk');

    if (userJson && unitsJson && isLogged) {
        const parsedUser = JSON.parse(userJson);
        this.user = new User(parsedUser); 
        this.units = JSON.parse(unitsJson);
        this.isLogged = isLogged === 'true';

        if (this.isLogged && this.units.length > 0) {
            ProductStore.checkIfShowProductSelector(this.units[0]);
        }
    } else {
        this.user = null;
        this.units = [];
        this.isLogged = false;
    }
}

    /**
     * New login data
     * @param data
     * @return {Promise.<void>}
     */
    @action
    async doLogin(data) {
        this.isLoading = true;

        let user = {
            "username": data.username.replace(/[.\-]/gi, ""),
            "password": data.password,
            "sourceIP": "192.168.1.125"
        };

        return await api.call(`/teachers/login/`, 'POST', user)
            .then(
                
                json => {
                    if (json.id) {
                        if (data.password === json.accessCode) {

                            this.isLoading = false;
                            this.user = new User({
                                id: json.id,
                                email: json.email,
                                name: json.name,
                                slug: json.slug,
                                auth_key: json.auth_key,
                                password: json.password_hash,
                                phone: json.phone,
                                profile: json.profile,
                                avatarUri: json.avatarUrl
                            });
                            this.units = json.units;

                            this.isLogged = true;
                            this._setLocalStoreData(this.user);

                            if (this.units.length > 0) {
                                ProductStore.checkIfShowProductSelector(this.units[0]);
                            }
                        }
                    }

                    return json;

                }).catch(error => {

                this.isLoading = false;
                return error;
            });
    }

    @action doLogout() {
        localStorage.removeItem('isLogged-wup-teachers-desk');
        localStorage.removeItem('user-wup-teachers-desk');
        localStorage.removeItem('units-wup-teachers-desk');
        ProductStore.resetProductSelection();
        this.user = null;
        this.isLogged = false;
        this.isLoading = false;
    }

    @computed get checkAuth() {
        return this.isLogged;
    }

    /**
     * Adiciona um usuário logado no local storage
     * @param user
     * @private
     */
    _setLocalStoreData(user) {
        localStorage.setItem('user-wup-teachers-desk', JSON.stringify(user));
        localStorage.setItem('units-wup-teachers-desk', JSON.stringify(this.units));
        localStorage.setItem('isLogged-wup-teachers-desk', true);
    }
}

export default new AuthStore();


// WEBPACK FOOTER //
// ./src/stores/AuthStore.js